import React from 'react';
import { motion } from 'framer-motion';

const FloatingSphere: React.FC = () => {
  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
      <motion.div
        className="absolute left-[8%] top-[14%] h-44 w-44 rounded-full border border-white/10 bg-white/[0.03] shadow-nebula backdrop-blur-xl"
        animate={{ y: [0, -18, 0], x: [0, 10, 0] }}
        transition={{ duration: 10, repeat: Infinity, ease: 'easeInOut' }}
      />
      <motion.div
        className="absolute bottom-[12%] right-[10%] h-64 w-64 rounded-full bg-gradient-to-br from-cosmic-aurora-sapphire/15 to-cosmic-aurora-amethyst/10 blur-3xl"
        animate={{ y: [0, 25, 0], x: [0, -20, 0] }}
        transition={{ duration: 16, repeat: Infinity, ease: 'easeInOut' }}
      />
    </div>
  );
};

export default FloatingSphere;
